export const softConversionEvents = {
  SOFT_CONVERSION_SHOW_IMAGES: 'imagesClick',
  SOFT_CONVERSION_FULLSCREEN_IMAGES: 'imagesFullscreenClick',
  SOFT_CONVERSION_SHOW_VEHICLE_OPTIONS: 'optionsClick',
  SOFT_CONVERSION_SHOW_VEHICLE_INFORMATION: 'informationClick',
  SOFT_CONVERSIONS_SUBSCRIBED: 'subscribed',
  SOFT_CONVERSIONS_INSURANCE: 'insuranceInterest',
  SOFT_CONVERSIONS_FINANCE: 'financeInterest',
  SOFT_CONVERSIONS_PAYMENT_OPTION: 'paymentOptionClick',
  SOFT_CONVERSIONS_SHARE: 'share',
  SOFT_CONVERSIONS_SHARE_INIT: 'shareInitialized',
  SOFT_CONVERSIONS_SAVE: 'save',
  SOFT_CONVERSIONS_SAVE_INIT: 'saveInitialized',
  SOFT_CONVERSIONS_ITEM_DEALER_MAP_CLICK: 'showDealerMap',
  SOFT_CONVERSIONS_ITEM_DEALER_ADDRESS_CLICK: 'outboundLinkGoogleMaps',
  SOFT_CONVERSIONS_ITEM_DEALER_PAGE_CLICK: 'linkClickToDealerPage',
  SOFT_CONVERSIONS_ITEM_DEALER_READ_MORE_CLICK: 'dealerContentReadMore',
  SOFT_CONVERSIONS_ITEM_PROPERTIES_TAB: 'carDetailTab',
  SOFT_CONVERSIONS_TAB_CLICK: 'tabClick',
  SOFT_CONVERSIONS_ITEM_PROPERTIES_TAB_FILTER_SEARCH: 'propertiesFilterSearch',
  SOFT_CONVERSIONS_ITEM_EQUIPMENT_FILTER_SEARCH: 'equipmentFilterSearch',
};

export const conversionEvents = {
  CONVERSION_MAIL_SENT: 'mail-sent',
  CONVERSION_MESSAGE_SENT: 'message-sent',
  CONVERSION_PHONENUMBER_CALL: 'phonenumber-call',
  CONVERSION_CHAT_STARTED: 'chat-started',
  CONVERSION_MAIL_VISIBLE: 'mail-visible',
  CONVERSION_PHONENUMBER_VISIBLE: 'phonenumber-visible',
  CONVERSION_ACTION_AUCTION_CLICK: 'action-auction-click',
  CONVERSION_ECOM_ORDER_CREATED: 'car-reservation',
  PHONENUMBER_VISIBLE_RETAILER: 'phonenumber-visible-retailer',
  MAIL_VISIBLE_RETAILER: 'mail-visible-retailer',
  MESSAGE_INITIATED_RETAILER: 'message-initiated-retailer',
  OUTBOUNDLINK_RETAILER: 'outbountlink-retailer',
  LOGIN_MODULE_IN_VIEWPORT: 'inViewport',
  LOGIN_MODULE_CLICK_LOGIN: 'clickLogin',
  SELL_TO_DEALER_START_APPLICATION: 'startApplication',
};

export const interactionEventType = {
  SAVE_OBJECT: 'Save object',
  SAVE_OBJECT_IN_SEARCH_RESULT: 'Save object in search result',
  MESSAGE_DEALER: 'Message dealer',
  SAVE_SEARCH_RESULT: 'Save search result',
  SAVE_CATEGORY: 'Save category',
  SELL_TO_DEALER: 'Sell to dealer',
  START_APPLICATION: 'Start application',
};

export const conversionType = {
  LINK_CLICK: 'linkClick',
  OUTBOUND_CLICK: 'outboundClick',
};

export const otherEvents = {
  MESSAGE_INITATED: 'message-initiated',
  MESSAGE_MODAL_CLOSE: 'message-modal-close',
  CONVERSION_PHONENUMBER_CALL_RETAILER: 'phonenumber-call-retailer',
  CONVERSION_MAIL_SENT_RETAILER: 'mail-sent-retailer',
};

export const eventTypes = {
  HAS_REGISTERED: 'hasRegistered',
  ITEM_VIEWED: 'view',
  PAGE_VIEW: 'pageview',
  ITEM_EXPOSED: 'exposure',
  CONVERSION: 'conversion',
  SOFT_CONVERSION: 'microConversion',
  SEARCH: 'search',
  NAVIGATION: 'navigation',
  SUBSCRIBED: 'subscribed',
  SHOWN_INTEREST: 'shownInterest',
  PRODUCT_CLICK: 'productClick',
  OTHER: 'other',
  CAR_DETAIL: 'carDetail',
  CAR_DETAIL_NAVIGATION: 'carDetailNavigation',
  LOGIN_MODULE: 'loginModule',
  SELL_TO_DEALER: 'sellToDealer',
};

export const assignmentEvents = {
  INIT: 'assignmentInitiated',
  RESUME: 'assignmentResume',
  PREVIEW: 'assignmentPreview',
  COMPLETED: 'assignmentCompleted',
  REMOVE: 'assignmentRemove',
  SAVE_DRAFT: 'assignmentSaveDraft',
  LOAD_DRAFT: 'assignmentLoadDraft',
  UPDATE_DRAFT: 'assignmentUpdateDraft',
};

export const creditApplicationEvents = {
  INIT: 'creditApplicationInitiated',
  SUBMITTED: 'creditApplicationSubmitted',
};

export const heroEvents = {
  HERO_LINK_CLICK: 'heroLinkClick',
  HERO_LINK_SECONDARY_CLICK: 'heroLinkSecondaryClick',
};

export const GuaranteeEvents = {
  MANUFACTURER_PACKAGE_BANNER_CLICK: 'manufacturerPackageBannerClick',
  MANUFACTURER_PACKAGE_MODAL_SHOW: 'manufacturerPackageModalShow',
  MANUFACTURER_PACKAGE_MODAL_READ_MORE: 'manufacturerPackageModalReadMore',
  MANUFACTURER_PACKAGE_PAGE_VIEW: 'manufacturerPackagePageView',
  MANUFACTURER_PACKAGE_PAGE_READ_MORE: 'manufacturerPackagePageReadMore',
  MANUFACTURER_PACKAGE_PAGE_GO_TO_SEARCH: 'manufacturerPackagePageGotoSearch',
  MRF_PACKAGE_PAGE_VIEW: 'mrfPackagePageView',
  GUARANTEE_INTERACTION: 'guaranteeInteraction',
};

export const ContentEvents = {
  NEWS_ITEM_SEARCH_MATCHED: 'newsItemSearchMatched',
  NEWS_ITEM_SEARCH_PAGING_CLICK: 'newsItemSearchPagingClick',
  NEWS_ITEM_SEARCH_SHOW_MORE: 'newsItemSearchShowMore',
  NEWS_ITEM_EXPOSURE: 'newsItemExposure',
  NEWS_ITEM_VIEW: 'newsItemView',
  NEWS_ITEM_SHARE: 'newsItemShare',
};

export const EcomEvents = {
  ECOM_INFO_CLICK: 'ecomInfoModalClick',
  ECOM_BUTTON_CLICK: 'ecomButtonClick',
  ECOM_MODAL_INTERNAL_EVENT: 'ecomModalInternalEvent',
};

export const ElectricCostEvents = {
  CHARGING_COST_PARAMETER_CHANGE: 'chargingCostParameterChange',
  CHARGING_COST_CUSTOMIZE_CLICK: 'chargingCostCustomizeClick',
  CHARGING_COST_DETAILS_CLICK: 'chargingCostDetailsClick',
};

export const LiveShopping = {
  LIVE_SHOPPING_INTERACTION: 'liveshoppingInteraction',
};

export const ValuationEvents = {
  MY_VEHICLE_VALUATION_SIGN_IN_MODAL: 'myVehicleValuationSignInModal',
  MY_VEHICLE_VALUATION_INIT: 'myVehicleValuationInit',
  MY_VEHICLE_VALUATION_COMPLETED: 'myVehicleValuationCompleted',
  MY_VEHICLE_SAVE: 'myVehicleSave',
  MY_VEHICLE_DELETE: 'myVehicleDelete',
  MY_VEHICLE_VALUATION_INFORMATION_CLICK: 'myVehicleValuationInformationClick',
  MY_VEHICLE_VALUATION_PARAMETER_CHANGE: 'myVehicleValuationParameterChange',
};
